// src/language/LocationTranslations.js
export const locationTranslations = {
    "en": {
        "divisions": {
            "Amravati": "Amravati",
            "Chhatrapati Sambhaji Nagar": "Chhatrapati Sambhaji Nagar",
            "Kokan": "Kokan",
            "Nagpur": "Nagpur",
            "Nashik": "Nashik",
            "Pune": "Pune"
        },
        "districts": {
            "Akola": "Akola",
            "Amravati": "Amravati",
            "Buldhana": "Buldhana",
            "Washim": "Washim",
            "Yavatmal": "Yavatmal",
            "Beed": "Beed",
            "Chhatrapati Sambhaji Nagar": "Chhatrapati Sambhaji Nagar",
            "Dharashiv": "Dharashiv",
            "Hingoli": "Hingoli",
            "Jalna": "Jalna",
            "Latur": "Latur",
            "Nanded": "Nanded",
            "Parbhani": "Parbhani",
            "Palghar": "Palghar",
            "Raigad": "Raigad",
            "Ratnagiri": "Ratnagiri",
            "Sindhudurg": "Sindhudurg",
            "Thane": "Thane",
            "Bhandara": "Bhandara",
            "Chandrapur": "Chandrapur",
            "Gadchiroli": "Gadchiroli",
            "Gondia": "Gondia",
            "Nagpur": "Nagpur",
            "Wardha": "Wardha",
            "Ahilyanagar": "Ahilyanagar",
            "Dhule": "Dhule",
            "Jalgaon": "Jalgaon",
            "Nandurbar": "Nandurbar",
            "Nashik": "Nashik",
            "Kolhapur": "Kolhapur",
            "Pune": "Pune",
            "Sangli": "Sangli",
            "Satara": "Satara",
            "Solapur": "Solapur"
        },
        "branchOffices": {
            "Akola": "Akola",
            "Amravati": "Amravati",
            "Buldhana": "Buldhana",
            "Washim": "Washim",
            "Yavatmal": "Yavatmal",
            "Beed": "Beed",
            "Chhatrapati Sambhaji Nagar": "Chhatrapati Sambhaji Nagar",
            "Dharashiv": "Dharashiv",
            "Hingoli": "Hingoli",
            "Jalna": "Jalna",
            "Latur": "Latur",
            "Nanded": "Nanded",
            "Parbhani": "Parbhani",
            "Palghar": "Palghar",
            "Raigad": "Raigad",
            "Ratnagiri": "Ratnagiri",
            "Sindhudurg": "Sindhudurg",
            "Thane": "Thane",
            "Bhandara": "Bhandara",
            "Chandrapur": "Chandrapur",
            "Gadchiroli": "Gadchiroli",
            "Gondia": "Gondia",
            "Nagpur": "Nagpur",
            "Wardha": "Wardha",
            "Shrirampur": "Shrirampur",
            "Ahilyanagar": "Ahilyanagar",
            "Dhule": "Dhule",
            "Jalgaon": "Jalgaon",
            "Nandurbar": "Nandurbar",
            "Nashik": "Nashik",
            "Kolhapur": "Kolhapur",
            "Pune": "Pune",
            "Baramati Branch": "Baramati Branch",
            "Sangli": "Sangli",
            "Satara": "Satara",
            "Solapur": "Solapur"
        }
    },
    "mr": {
        "divisions": {
            "Amravati": "अमरावती",
            "Chhatrapati Sambhaji Nagar": "छत्रपती संभाजीनगर",
            "Kokan": "कोकण",
            "Nagpur": "नागपूर",
            "Nashik": "नाशिक",
            "Pune": "पुणे"
        },
        "districts": {
            "Akola": "अकोला",
            "Amravati": "अमरावती",
            "Buldhana": "बुलढाणा",
            "Washim": "अकोला",
            "Yavatmal": "यवतमाळ",
            "Beed": "बीड",
            "Chhatrapati Sambhaji Nagar": "छत्रपती संभाजीनगर",
            "Dharashiv": "धाराशिव",
            "Hingoli": "हिंगोली",
            "Jalna": "जालना",
            "Latur": "लातूर",
            "Nanded": "नांदेड",
            "Parbhani": "परभणी",
            "Palghar": "पालघर",
            "Raigad": "रायगड",
            "Ratnagiri": "रत्नागिरी",
            "Sindhudurg": "रत्नागिरी",
            "Thane": "ठाणे",
            "Bhandara": "भंडारा",
            "Chandrapur": "गडचिरोली",
            "Gadchiroli": "गडचिरोली",
            "Gondia": "गोंदिया",
            "Nagpur": "नागपूर",
            "Wardha": "वर्धा",
            "Ahilyanagar": "अहमदनगर",
            "Dhule": "धुळे",
            "Jalgaon": "जळगाव",
            "Nandurbar": "नंदुरबार",
            "Nashik": "नाशिक",
            "Kolhapur": "कोल्हापूर",
            "Pune": "पुणे",
            "Sangli": "सांगली",
            "Satara": "सातारा",
            "Solapur": "सोलापूर"
        },
        "branchOffices": {
            "Akola": "शाखा कार्यालय अकोला",
            "Amravati": "शाखा कार्यालय अमरावती",
            "Buldhana": "शाखा कार्यालय बुलढाणा",
            "Washim": "शाखा कार्यालय अकोला",
            "Yavatmal": "शाखा कार्यालय यवतमाळ",
            "Beed": "शाखा कार्यालय बीड",
            "Chhatrapati Sambhaji Nagar": "शाखा कार्यालय छत्रपती संभाजीनगर",
            "Dharashiv": "शाखा कार्यालय धाराशिव",
            "Hingoli": "शाखा कार्यालय हिंगोली",
            "Jalna": "शाखा कार्यालय जालना",
            "Latur": "शाखा कार्यालय लातूर",
            "Nanded": "शाखा कार्यालय नांदेड",
            "Parbhani": "शाखा कार्यालय परभणी",
            "Palghar": "शाखा कार्यालय पालघर",
            "Raigad": "शाखा कार्यालय रायगड",
            "Ratnagiri": "शाखा कार्यालय रत्नागिरी",
            "Sindhudurg": "शाखा कार्यालय सिंधुदुर्ग",
            "Thane": "शाखा कार्यालय ठाणे",
            "Bhandara": "शाखा कार्यालय भंडारा",
            "Chandrapur": "शाखा कार्यालय चंद्रपूर",
            "Gadchiroli": "शाखा कार्यालय गडचिरोली",
            "Gondia": "शाखा कार्यालय गोंदिया",
            "Nagpur": "शाखा कार्यालय नागपूर",
            "Wardha": "शाखा कार्यालय वर्धा",
            "Shrirampur": "शाखा कार्यालय श्रीरामपूर",
            "Ahilyanagar": "शाखा कार्यालय अहमदनगर",
            "Dhule": "शाखा कार्यालय धुळे",
            "Jalgaon": "शाखा कार्यालय जळगाव",
            "Nandurbar": "शाखा कार्यालय नंदुरबार",
            "Nashik": "शाखा कार्यालय नाशिक",
            "Kolhapur": "शाखा कार्यालय कोल्हापूर",
            "Pune": "शाखा कार्यालय पुणे",
            "Baramati Branch": "शाखा कार्यालय बारामती",
            "Sangli": "शाखा कार्यालय सांगली",
            "Satara": "शाखा कार्यालय सातारा",
            "Solapur": "शाखा कार्यालय सोलापूर"
        }
    }
};